<template>
  <div class="intro">
    <div class="d-block w-100">
      <b-skeleton width="20%" height="30px" class="mx-auto my-4"></b-skeleton>
      <b-skeleton width="60%" height="20px" class="mx-auto my-4"></b-skeleton>
    </div>
    <hr />

    <b-card-group>
      <b-card v-for="(module) in modules" no-body img-top :key="module">
        <b-skeleton-img card-img="top" aspect="3:1"></b-skeleton-img>
        <b-card-body>
          <b-skeleton width="40%" height="25px"></b-skeleton>
        </b-card-body>
      </b-card>
    </b-card-group>

    <div class="d-flex w-100">
      <b-skeleton type="button" width="50%" class="atm-button bg-main mx-auto my-4">
      </b-skeleton>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      modules: [1, 2, 3, 4, 5],
    };
  },
};
</script>
